import { render } from "./file_source.vue?vue&type=template&id=0480144c"
import script from "./file_source.vue?vue&type=script&lang=js"
export * from "./file_source.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__